import { gql } from 'apollo-boost'

const inviaAdAffitti = gql`
  mutation inviaAdAffitti($clienteId: Int!) {
    inviaAdAffitti(clienteId: $clienteId)
  }
`

export default inviaAdAffitti


// WEBPACK FOOTER //
// ./src/graphql/mutations/inviaAdAffitti.js